import { render, staticRenderFns } from "./PartnersSection.vue?vue&type=template&id=1601f31a&"
import script from "./PartnersSection.vue?vue&type=script&lang=js&"
export * from "./PartnersSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports